/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { TokenInfo } from '../models/token-info.models';

export enum LoadTokenActions {
  LOAD_TOKEN_SUCCESS = '[Auth] Load token Success',
  LOAD_TOKEN_ERROR = '[Auth] Load token Error',
}

export class LoadTokenSuccess implements Action {
  public readonly type = LoadTokenActions.LOAD_TOKEN_SUCCESS;
  constructor(public payload: {token: TokenInfo}) {}
}

export class LoadTokenError implements Action {
  public readonly type = LoadTokenActions.LOAD_TOKEN_ERROR;
}

export type LoadTokenAction =
  LoadTokenSuccess |
  LoadTokenError;
